<template>
    <!-- 承诺书上传 -->
    <div>
        <van-cell is-link @click="showFileType=true">
            <div class="list-box">
                <p>选择材料类型</p>
                <p v-text="fileType" :class="{'color-gray': fileType=='请选择'}"></p>
            </div>
        </van-cell>

        <van-popup v-model="showFileType" position="bottom">
            <van-cell v-for="(it, index) in fileTypeList" :key="index" @click="selectThisType(it)">
                <p v-text="it.nameZh" download></p>
            </van-cell>
        </van-popup>

        <div id=NewsToolBox></div>

        <div class="desc-box" v-show="fileType != '请选择'">
            <p>说明: <span class="color-gray" v-text="fileTypeDesc"></span></p>
            <p class="download-file" @click="downloadFileModel">复制链接</p>
            <!--            <a :href="downloadUrl" download="download.png">下载</a>-->

            <van-uploader v-model="fileList" :after-read="afterRead" :before-read="beforeRead" :max-count="1">
                <van-button icon="photo" type="primary">上传{{fileType}}</van-button>
            </van-uploader>
        </div>
        <div>
            <van-cell v-for="(it, index) in uploadHistory" :key="index">
                <van-image width="5rem" height="5rem" fit="contain" :src="it.srcVal"/>
                <p class="upload-time">上传时间: <span v-text="it.createTime"></span></p>
            </van-cell>
        </div>
        <bottom-tab></bottom-tab>
    </div>
</template>

<script>
    import Vue from 'vue';
    import api from '../../http/api.js'

    import {
        Uploader,
        Cell,
        Popup,
        Toast,
        Image
    } from 'vant';

    Vue.use(Uploader);
    Vue.use(Image);
    Vue.use(Toast);
    Vue.use(Cell);
    Vue.use(Popup);


    export default {
        data() {
            return {
                fileList: [], // 已上传的文件列表   用于预览
                fileType: '请选择',
                fileTypeValue: '', // 选择文件类型的name值
                fileTypeDesc: '', // 文件类型的描述
                fileTypeList: [], // 文件类型列表
                downloadUrl: '', //文件下载地址
                showFileType: false,
                schoolId: window.localStorage.getItem('scId'),
                schoolName: '',
                deptId: window.localStorage.getItem('scDeptId'),
                deptName: '',
                userId: window.localStorage.getItem('sid'), // 学生id
                userName: '', // 学生姓名
                c_userId: window.localStorage.getItem('uid'),
                uploadHistory: [], // 上传历史列表
            }
        },
        methods: {
            pageInit() {
                let areaId = 36
                let key = 'school_' + areaId + '_areaTempInfo'
                api.loadAreaTempInfo(key).then(res => {
                    console.log(res);
                    if (res.data.code == 200) {
                        let list_ = JSON.parse(res.data.data.configValue).fileUploadKeys
                        for (let i = 0; i < list_.length; i++) {
                            this.fileTypeList.push(list_[i])
                        }
                    } else {
                        Toast('获取失败' + res.data.msg)
                    }
                })

                this.getSchoolMsg(); // 获取学校名字
                this.getDeptMsg(); // 获取部门和学生名字
            },
            getUploadHistory() {
                this.uploadHistory = []
                let params = {
                    opType: 'uploadFileWithType',
                    srcType: this.fileTypeValue,
                    tarId: this.userId
                }
                api.loadUploadEvent(params).then(res => {
                    if (res.data.code == 200) {
                        for (let i = 0; i < res.data.data.length; i++) {
                            this.uploadHistory.push(res.data.data[i])
                        }
                    } else {
                        Toast('获取上传历史失败' + res.data.msg)
                    }
                })
            },
            getSchoolMsg() {
                api.getSchoolMsg(this.schoolId).then(res => {
                    if (res.data.code == 200) {
                        this.schoolName = res.data.data.deptName
                    } else {
                        Toast('获取学校信息失败' + res.data.msg)
                    }
                })
            },
            getDeptMsg() {
                api.getUserInfo(this.userId).then(res => {
                    // console.log(res);
                    if (res.data.code == 200) {
                        this.deptName = res.data.data.depts[0].name
                        this.userName = res.data.data.name
                    } else {
                        Toast('获取失败：' + res.data.msg)
                    }
                })
            },
            selectThisType(it) {
                this.fileType = it.nameZh
                this.fileTypeValue = it.name
                this.fileTypeDesc = it.desc
                this.downloadUrl = it.exampleUrl
                this.showFileType = false
                this.fileList = []
                this.getUploadHistory(); // 获取历史上传记录
            },
            downloadFileModel() {
                function copy(str) {
                    var save = function(e) {
                        e.clipboardData.setData('text/plain', str); //下面会说到clipboardData对象
                        e.preventDefault(); //阻止默认行为
                    }
                    document.addEventListener('copy', save);
                    document.execCommand("copy"); //使文档处于可编辑状态，否则无效
                }

                function copyText(text) {
                    var textarea = document.createElement("textarea"); //创建input对象
                    var currentFocus = document.activeElement; //当前获得焦点的元素
                    var toolBoxwrap = document.getElementById('NewsToolBox'); //将文本框插入到NewsToolBox这个之后
                    toolBoxwrap.appendChild(textarea); //添加元素
                    textarea.value = text;
                    textarea.focus();
                    if (textarea.setSelectionRange) {
                        textarea.setSelectionRange(0, textarea.value.length); //获取光标起始位置到结束位置
                    } else {
                        textarea.select();
                    }
                    try {
                        var flag = document.execCommand("copy"); //执行复制
                    } catch (eo) {
                        var flag = false;
                    }
                    toolBoxwrap.removeChild(textarea); //删除元素
                    currentFocus.focus();
                    return flag;
                }

                // copy(this.downloadUrl)
                copyText(this.downloadUrl)
                Toast('复制成功')
                // window.location.href = this.downloadUrl
            },
            afterRead(file) {
                file.status = 'uploading';
                file.message = '上传中...';

                console.log(file);

                let formData = new FormData();
                formData.append('bucketName', 'hd-file');
                // {schoolId}_{schooName}/{dpetId}_{deptName}/{studentUserId}_{studentUserName}.jpg
                formData.append('filePath', this.schoolId + '_' + this.schoolName + '/' + this.deptId + '_' + this.deptName + '/' +
                    this.userId + '_' + this.userName + '/' + this.fileTypeValue + '_' + new Date().getTime() + '.jpg');
                formData.append('image', file.file);

                api.uploadFile(formData).then(res => {
                    if (res.status === 200) {
                        /*这里做处理*/
                        Toast('上传成功')
                        file.status = 'done';
                        file.message = '成功';

                        api.uploadSuccess(this.c_userId, this.fileTypeValue, res.data.data, this.userId).then(r => {
                            if (r.data.code == 200) {
                                Toast('记录更新成功')
                                this.fileList = []
                                this.getUploadHistory(); // 获取历史上传记录
                            } else {
                                Toast('更新失败' + r.data.msg)
                            }
                        })
                    } else {
                        Toast('上传失败' + res.data.msg)
                    }
                })
            },
            // 返回布尔值
            beforeRead(file) {
                if (file.type !== 'image/jpeg') {
                    Toast('请上传 jpg 格式图片');
                    return false;
                }
                return true;
            },
        },
        mounted() {
            this.pageInit()
        }
    }
</script>

<style scoped>
    .list-box {
        display: flex;
        justify-content: space-between;
    }

    .list-box p {
        margin: 0;
        line-height: 55px;
    }

    .van-cell__right-icon {
        line-height: 55px;
    }

    .desc-box {
        padding: 10px 16px;
    }

    .download-file {
        color: #409EFF;
    }

    .upload-time {
        margin: 10px;
    }
</style>
